export default [

     {
          path: '/risk-function',
          name: 'RiskFunction',
          component: () => import("@/views/Page/RiskFunction/RiskFunction.vue"),
           meta: {
               title: 'Risk Function',
          },
     }
];